import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import dayjs from 'dayjs';
import { find, get } from 'lodash';
import { Space, Button, Form, Alert, Radio, Divider, Row, Col, Tooltip, Upload, Input, Modal, Collapse } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import * as Yup from 'yup';
import Viewer from 'react-viewer';

import * as constants from '../constants';
import {
    setSelectedDetailReportIsDirty,
    getLinkedFile
} from '../actions';
import ReportHeader from './ReportHeader';
import ReportWorkflowActions from './ReportWorkflowActions';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';
import companies from '../../companies';
//import remarks from '../../remarks';
import currentuser from '../../currentuser';

//const { RemarksGrid } = remarks;

const { SelectInput, TextInput, TextArea, CheckboxInput, DatePickerInput, TextInputSelect, NumberInput, PdfViewer, DisplayFormikState, FormDirtyTracker } = core;
const FormItem = Form.Item;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 3,
        },
    },
};
const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class ReportForm extends Component {

    state = {

        showViewer: false,
        imageloaded: false,
        url: '',
        filename: '',
        type: '',
        fileList: [],
        fileError: '',
    }

    async UNSAFE_componentWillMount() {
        if (this.props.datacontext.idLinkedFile) {
            let linkedfile = await this.props.getLinkedFile(this.props.datacontext.idLinkedFile);
            this.setState({
                fileList: [{
                    uid: linkedfile.idLinkedFile,
                    name: linkedfile.filename,
                    status: 'done',
                    url: linkedfile.url
                }],
                url: linkedfile.url,
                filename: linkedfile.filename,
                fileid: linkedfile.idLinkedFile,
                type: linkedfile.contenttype,
                imageloaded: true,
                filechanged: false,
            })
        }
    }

    onCancel = async () => {
        this.formik.resetForm();
        if (this.props.datacontext.idLinkedFile) {
            let linkedfile = await this.props.getLinkedFile(this.props.datacontext.idLinkedFile);
            this.setState({
                fileList: [{
                    uid: linkedfile.idLinkedFile,
                    name: linkedfile.filename,
                    status: 'done',
                    url: linkedfile.url
                }],
                url: linkedfile.url,
                filename: linkedfile.filename,
                fileid: linkedfile.idLinkedFile,
                type: linkedfile.contenttype,
                imageloaded: true,
                filechanged: false,
            })
        }
    }

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            try {
                if (this.state.filechanged) {
                    await this.props.onSavePlusFile(values, this.state.fileList[0])
                } else {
                    await this.props.onSave(values);
                }

                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors();
            }
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReportForm', key);
    }

    FormSchema = () => {
        let schema = Yup.object().shape({
            contactPerson: Yup.string().required('*'),
            contactCompany: Yup.string().required('*'),
            contactFunction: Yup.string().required('*'),
            occasion: Yup.string().required('*'),
            gift: Yup.string().required('*'),
            amount: Yup.number().required('*'),
            date: Yup.date().required('*'),
            idReportCategory: Yup.number().integer().required('*'),
            idReportType: Yup.number().integer().required('*'),
            declaration: Yup.bool().when(
                'idReportType',
                (idReportType, schema) => (idReportType == 1 || idReportType == 2) ? Yup.bool().required('*').oneOf([true], '*') : schema,
            )
        })

        return schema;
    }
    onChange = e => {
        this.formik.setFieldValue('idReportType', e.target.value)
    };
    onViewImage = () => {
        this.setState({
            showViewer: true,
        });
    }
    onCloseViewer = () => {
        this.setState({
            showViewer: false,
        });
    }
    onRemove = (file) => {
        this.setState((state) => {
            const index = state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
                imageloaded: false,
                url: '',
                type: '',
                filechanged: true,
            };
        });
    }
    beforeUpload = async (file) => {
        let result = false;
        if (file.type.startsWith("image")) {
            let url = await getBase64(file);
            this.setState(state => ({
                fileList: [file],
                url,
                type: file.type,
                imageloaded: true,
                filechanged: true,
            }));
        } else {
            this.setState(state => ({
                fileList: [file],
                url: '',
                type: '',
                imageloaded: false,
                filechanged: true,
            }));
        }
        return result;
    }

    setSelectedDetailReportIsDirty = (dirty) => {
        this.props.setSelectedDetailReportIsDirty(dirty);
    }

    CreateForm = (props) => {
        const radioStyle = {
            display: 'inline',
            height: '30px',
            lineHeight: '30px',
        };

        let categories = this.props.picklists.reportCategories.filter(c => c.visible);

        const firstFormPart = <>
            <TextInput {...props} readOnly={true} name="number" label={this.label("Number")} formItemLayout={formItemLayout} />
            <Form.Item label={this.label("ReportType")} {...formItemLayout}>
                <Radio.Group disabled={this.props.readOnly} onChange={this.onChange} value={props.values.idReportType}>
                    <Radio style={radioStyle} value={common.REPORT_TYPES.IGive}>
                        {this.label("IGive")}
                    </Radio>
                    <Radio style={radioStyle} value={common.REPORT_TYPES.IReceive}>
                        {this.label("IReceive")}
                    </Radio>
                    <Radio style={radioStyle} value={common.REPORT_TYPES.IDecline}>
                        {this.label("IDecline")}
                    </Radio>
                </Radio.Group>
            </Form.Item>

            <Row align="middle">
                <Col span={17} offset={5} >
                    <Divider className="formDivider" orientation="left">{this.label(`Contact${props.values.idReportType}`)}</Divider>
                </Col>
            </Row>

            <TextInput readOnly={this.props.readOnly} {...props} name="contactPerson" label={this.label("ContactPerson")} formItemLayout={formItemLayout} />
            <TextInput readOnly={this.props.readOnly} {...props} name="contactCompany" label={this.label("ContactCompany")} formItemLayout={formItemLayout} />
            <CheckboxInput {...props} name="governmentCompany" label={this.label("GovernmentCompany")} formItemLayout={formItemLayout} />
            <TextInput readOnly={this.props.readOnly} {...props} name="contactFunction" label={this.label("ContactFunction")} formItemLayout={formItemLayout} />

            <Row align="middle">
                <Col span={17} offset={5} >
                    <Divider className="formDivider" orientation="left">{this.label(`Occasion${props.values.idReportType}`)}</Divider>
                </Col>
            </Row>
            <TextArea readOnly={this.props.readOnly} {...props} name="occasion" label=' ' colon={false} rows={3} formItemLayout={formItemLayout} />

            <Row align="middle">
                <Col span={17} offset={5} >
                    <Divider className="formDivider" orientation="left">{this.label(`Gift${props.values.idReportType}`)}</Divider>
                </Col>
            </Row>
            <TextArea readOnly={this.props.readOnly} {...props} name="gift" label=' ' colon={false} rows={3} formItemLayout={formItemLayout} />

            <SelectInput readOnly={this.props.readOnly} {...props} name="idReportCategory" nameField="name" idField="id" items={categories} label={this.label("Category")} formItemLayout={formItemLayout} />
            <Form.Item {...formItemLayout} label={this.label("Amount")}>
                <Row align="middle">
                    <Col span={10}>
                        <NumberInput readOnly={this.props.readOnly} {...props} decimalSeparator=',' step={0.01} precision={2} name="amount" min={0} formItemLayout={formItemLayout} />
                    </Col>
                    <Col span={6} >
                        <a href='https://www1.oanda.com/currency/converter/' target="_blank">currency converter</a>
                    </Col>
                </Row>
            </Form.Item>
            <DatePickerInput readOnly={this.props.readOnly} {...props} name="date" showTime={false} label={this.label("Date")} formItemLayout={formItemLayout} />
            {(props.values.idReportType == common.REPORT_TYPES.IGive || props.values.idReportType == common.REPORT_TYPES.IReceive) &&
                <>
                    <CheckboxInput readOnly={this.props.readOnly} {...props} name="declaration" label={this.label("Declaration")} formItemLayout={formItemLayout} />
                    <Row align="middle">
                        <Col span={16} offset={6} >
                            <span style={{ display: 'block', marginTop: -10 }} >{this.label(`Declaration${props.values.idReportType}`)}</span>
                            <br />
                        </Col>
                    </Row>
                </>
            }
        </>
        const secondFormPart = <><Form.Item label={this.label("File")} labelCol={{ span: 4 }} wrapperCol={{ span: 10 }} hasFeedback={this.state.fileList.length < 1} validateStatus={this.state.fileError} >
            <Upload disabled={this.props.readOnly} beforeUpload={this.beforeUpload} onRemove={this.onRemove} fileList={this.state.fileList} >
                <Button disabled={this.props.readOnly} icon={<UploadOutlined />}>{this.label("SelectFile")}</Button>
            </Upload>
        </Form.Item>
            {this.state.imageloaded && this.state.type.startsWith("image") &&
                <Tooltip title={this.label("ClickForLarge")}>
                    <div className="reportimage" >
                        <img src={this.state.url} className="image" onClick={this.onViewImage} />
                    </div>
                </Tooltip>
            }
            {this.state.imageloaded && this.state.type.startsWith("application/pdf") &&
                <PdfViewer url={this.state.url} filename={this.state.filename} fileid={this.state.fileid} height={this.props.contentHeight - 500} />
            }
        </>


        return (
            <Form layout='horizontal' style={{ margin: 10, maxHeight: this.props.contentheight - 10, overflowY: 'auto', overflowX: 'hidden' }}>
                <Collapse items={[{
                    key: '1',
                    label: `${this.label("H_Common")} - ${props.initialValues.username} - ${this.label("Number")} : ${props.initialValues.number}`,
                    children: <ReportHeader labels={this.props.labels} {...props.initialValues} contentWidth={this.props.contentWidth} contentHeight={this.props.contentHeight} />,
                }]} />
                <Divider />
                <FormItem {...tailFormItemLayout} >
                    <Space.Compact>
                        <Button size='small' type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || this.props.readOnly} > {this.label("Save")} </Button>
                        <Button size='small' disabled={props.isSubmitting || this.props.readOnly} onClick={this.onCancel}>{this.label("Cancel")} </Button>
                    </Space.Compact>
                    <ReportWorkflowActions onRedirect={this.props.onRedirect} onSave={async () => { await this.props.onSave(props.values) }} />
                    {props.isSubmitting &&
                        <Alert
                            message={this.label("Saving")}
                            style={{ marginTop: 20 }}
                        />
                    }
                </FormItem>
                {(props.values.idReportStatus == common.STATUSES.Rejected) && props.values.wfReason && props.values.wfReason.length > 0 &&
                    <Alert style={{ marginRight: 25 }} banner type="error" closable
                        message={<div>{this.label("ReasonRejected")}: '{props.values.wfReason}'</div>}
                    />
                }
                <Divider />
                <Row>
                    <Col span={16}>
                        {firstFormPart}
                    </Col>
                    <Col span={8}>
                        {secondFormPart}
                    </Col>
                </Row>

                <Viewer container={this.container} noNavbar={true} attribute={false}
                    open={this.state.showViewer}
                    // defaultSize={{width: ((this.props.contentWidth / 2) - 10) }}
                    onClose={this.onCloseViewer} onMaskClick={this.onCloseViewer}
                    images={[{ src: this.state.url, alt: '' }]}
                />
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true} validateOnBlur={false} validateOnChange={false}
                initialValues={this.props.datacontext}
                validationSchema={this.FormSchema()}
                onSubmit={this.onSave}
                innerRef={p => (this.formik = p)}
            >
                {(props) => <><FormDirtyTracker dirty={props.dirty} onDirtyChange={this.setSelectedDetailReportIsDirty} />{this.CreateForm(props)}</>}
            </Formik>
        );
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {
    setSelectedDetailReportIsDirty,
    getLinkedFile
})(ReportForm);


